import React from "react";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import { Button, Box, ButtonBase } from "@material-ui/core/";
// core components
import Card from "components/uikit/Card/Card.js";
import CardBody from "components/uikit/Card/CardBody.js";
import imagesStyles from "assets/jss/material-kit-react/imagesStyles.js";
import { cardTitle } from "assets/jss/material-kit-react.js";
import ArticleDate from "components/atoms/ArticleDate";
import Html2Text from "components/atoms/Html2Text";
import useComponentSize from "@rehooks/component-size";
import { Article } from "API";
import styled from "styled-components";
import { navigate } from "gatsby";
import { getCfUrl } from "settings/storageSettings";
import { LazyLoadImage } from "react-lazy-load-image-component";

const styles = {
  ...imagesStyles,
  cardTitle: {
    ...cardTitle,
    fontSize: "15px",
    height: "4rem",
    marginBottom: "0.8rem",
    display: "block",
    overflow: "hidden",
    "@supports (-webkit-line-clamp: 2)": {
      display: "-webkit-box",
      boxOrient: "vertical",
      lineClamp: 3,
      wordBreak: "break-all",
      overflow: "hidden",
    },
  },
  root: {
    minHeight: "320px",
    width: "100%",
  },
  descriptionText: {
    height: "2rem",
    fontSize: "12px",
    textOverflow: "ellipsis",
  },
  category: {
    height: "1rem",
  },
  textMuted: {
    color: "#6c757d",
  },
};

type Props = {
  article: Article;
  showCategory?: boolean;
};
const useStyles = makeStyles(styles);

const CategoryReact = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 11px;
  text-align: center;
  line-height: 20px;
  border: solid 1px #000;
`;
const PrRect = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 11px;
  text-align: center;
  line-height: 20px;
  border-right: solid 1px #000;
  border-top: solid 1px #000;
  border-bottom: solid 1px #000;

  div {
    margin: 0 9px;
  }
`;

export default function Cards(props: Props) {
  const { article, showCategory } = props;
  const classes = useStyles();
  let ref = React.useRef(null);
  let size = useComponentSize(ref);

  return (
    <>
      <div>
        <Card className={classes.root}>
          <a href={`/articles/${article.slug}`} ref={ref}>
            <LazyLoadImage
              placeholderSrc="/images/placeholder.png"
              className={classes.imgCardTop}
              src={article.mainImage ? getCfUrl(article.mainImage.url) : ""}
              width="100%"
              height={`${Math.floor(size.width * 0.637)}px`}
              effect="blur"
              alt={article.title}
            />
          </a>

          <CardBody>
            <div style={{ padding: "0 4px" }}>
              {article.startDateTime && (
                <p style={{ textAlign: "center" }}>
                  <small className={classes.textMuted}>
                    {article.startDateTime && (
                      <ArticleDate date={article.startDateTime} />
                    )}
                  </small>
                </p>
              )}

              <a href={`/articles/${article.slug}`}>
                <h4 className={classes.cardTitle}>{article.title}</h4>
              </a>

              <p className={classes.descriptionText}>
                <Html2Text value={article.description} />
              </p>

              <Button
                href={`/articles/${article.slug}`}
                color="primary"
                style={{ marginTop: "5px", paddingLeft: "0px" }}
              >
                続きを読む
              </Button>

              <>
                {showCategory && article.category && (
                  <Box
                    display="flex"
                    marginBottom={2}
                    style={{ width: "100%" }}
                  >
                    <>
                      {article.category && (
                        <Box width="100%">
                          <ButtonBase
                            style={{ width: "100%" }}
                            onClick={() =>
                              navigate(`/categories/${article.category.slug}`)
                            }
                          >
                            <CategoryReact>
                              {article.category.name}
                            </CategoryReact>
                          </ButtonBase>
                        </Box>
                      )}
                      {article.prFlg && (
                        <Box flexShrink={0}>
                          <ButtonBase>
                            <PrRect>
                              <div>PR</div>
                            </PrRect>
                          </ButtonBase>
                        </Box>
                      )}
                    </>
                  </Box>
                )}
              </>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
}

Cards.defalutProps = {
  showCategory: false,
};
